import { createAction, props } from '@ngrx/store';

const state = '[Products]';

// ---- Email event types ----
export const loadEmailProducts = createAction(`${state} Load email products`);
export const loadEmailProductsSuccess = createAction(
  `${state} Load email products success`,
  props<{ emailEventTypesByProductId: { [productId: string]: string[] } }>()
);
export const loadEmailProductsFailure = createAction(
  `${state} Load email products failure`,
  props<{ error: string }>()
);

// ---- Public email event types ----
export const loadPublicEmailProducts = createAction(`${state} Load public email products`);
export const loadPublicEmailProductsSuccess = createAction(
  `${state} Load public email products success`,
  props<{ publicEmailEventTypesByProductId: { [productId: string]: string[] } }>()
);
export const loadPublicEmailProductsFailure = createAction(
  `${state} Load public email products failure`,
  props<{ error: string }>()
);

// ---- SMS event types ----
export const loadSmsProducts = createAction(`${state} Load SMS products`);
export const loadSmsProductsSuccess = createAction(
  `${state} Load SMS products success`,
  props<{ smsEventTypesByProductId: { [productId: string]: string[] } }>()
);
export const loadSmsProductsFailure = createAction(
  `${state} Load SMS products failure`,
  props<{ error: string }>()
);

// ---- Teams chat singles ----
export const loadChatSingleProducts = createAction(`${state} Load chat single products`);
export const loadChatSingleProductsSuccess = createAction(
  `${state} Load chat single products success`,
  props<{ chatSingleCodesByProductId: { [productId: string]: string[] } }>()
);
export const loadChatSingleProductsFailure = createAction(
  `${state} Load chat single products failure`,
  props<{ error: string }>()
);

// ---- Teams chat groups ----
export const loadChatGroupProducts = createAction(`${state} Load chat group products`);
export const loadChatGroupProductsSuccess = createAction(
  `${state} Load chat group products success`,
  props<{ chatGroupCodesByProductId: { [productId: string]: string[] } }>()
);
export const loadChatGroupProductsFailure = createAction(
  `${state} Load chat group products failure`,
  props<{ error: string }>()
);

// ---- Teams channels ----
export const loadChannelProducts = createAction(`${state} Load channel products`);
export const loadChannelProductsSuccess = createAction(
  `${state} Load channel products success`,
  props<{ channelProductIds: string[] }>()
);
export const loadChannelProductsFailure = createAction(
  `${state} Load channel products failure`,
  props<{ error: string }>()
);
